import { getREST } from '@repo/commons/utils'
import type { SupersetConfig } from '@repo/commons/models'

export async function getSupersetToken(appName: string): Promise<string> {
	const params: Record<string, string> = { appName }

	return getREST<string>('/api/shared/superset', params).then((response) => {
		console.log(response.data)
		return response.data
	})
}

export async function initSuperset(appName: string): Promise<SupersetConfig> {
	const params: Record<string, string> = { appName }

	return getREST<SupersetConfig>('/api/shared/superset/init', params).then(
		(response) => response.data
	)
}
